










import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class InputText extends Vue {

    public mdInputText: string = '';

    @Prop()
    public mdIcon!: string;

    @Prop()
    public mdPlaceholder!: string;

    @Prop()
    public mdInputError!: string;

    @Prop()
    public mdInputLabel!: string;

    private mounted(){
        if(this.mdPlaceholder && !this.mdInputText){
            this.mdInputText = this.mdPlaceholder
        }
    }

    public mdOnChange($event) {
        this.$emit('onChange', $event.target.value);
    }

     public get mdFieldClass(){
      return !this.mdInputError ? '' : 'md-invalid';
  }
}
